<script>
	import icons from './icons.js';
	export let name = 'dashboard';
</script>

<div class="icon">
	{@html icons[name]}
</div>

<style>
	.icon {
		line-height: 0;
	}
	:global(.icon svg) {
		width: 20px;
		height: 20px;
	}
</style>
